import axios from 'axios';
import {
  addressDetailUrl,
  reverseGeocodeUrl,
  saveAddressUrl,
  deleteAddressUrl,
  convertAddressToCoordinatesUrl,
  editAddressUrl,
} from '../url';
import { getToken, getTokenHeader } from '../../../../screen/auth/action';

export const reverseGeocodeAction = async (lat, lng) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(
        `${reverseGeocodeUrl()}?latitude=${lat}&longitude=${lng}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const addressDetailAction = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${addressDetailUrl()}?company_esi_id=${company_esi_id}`, { ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const saveAddressAction = async (payload) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(saveAddressUrl(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const convertAddressToCoordinates = async (address) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .post(
        convertAddressToCoordinatesUrl(),
        { address },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const deleteAddressAction = async (addressId) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .delete(`${deleteAddressUrl()}/${addressId}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// export const editAddressAction = async (addressId, payload,companyEsiId) => {
//   return new Promise(async (next) => {
//     let token = await getToken();

//     await axios
//       .patch(`${editAddressUrl()}/${addressId}?company_esi_id=${companyEsiId}`, payload, getTokenHeader(token))
//       .then(async ({ data }) => {
//         return next(data);
//       })
//       .catch((err) => {
//         return next({ error: err });
//       });
//   });
// }

